import type { CellValue, Column } from './columns.js';

/** Renders a cell for CSV: booleans become `x` / empty, numbers use `.` as decimal separator. */
export function csvCell(value: CellValue): string {
  if (typeof value === 'boolean') return value ? 'x' : '';
  return String(value);
}

/** Quotes a field when it contains a comma, quote, CR or LF (RFC 4180), doubling quotes. */
export function csvField(text: string): string {
  return /[",\r\n]/.test(text) ? `"${text.replaceAll('"', '""')}"` : text;
}

/**
 * RFC 4180 CSV with comma separators and CRLF line breaks (no trailing line break). The header row
 * uses `translate(column.labelKey)` (default: the key itself).
 */
export function toCsv<R>(
  rows: readonly R[],
  columns: readonly Column<R>[],
  translate: (labelKey: string) => string = (k) => k,
): string {
  const header = columns.map((c) => csvField(translate(c.labelKey))).join(',');
  const body = rows.map((row) => columns.map((c) => csvField(csvCell(c.value(row)))).join(','));
  return [header, ...body].join('\r\n');
}
